<template>
  <Teleport to="body">
    <div
      class="new-ui ui-toast-host ui-toast-host--top ui-toast-host--right"
      :style="insetStyle"
      aria-live="polite"
    >
      <div class="ui-toast-stack">
        <Transition name="ui-toast">
          <UiToast
            v-if="visible"
            :toast="versionToast"
            @action="emit('reload')"
            @close="emit('close')"
          />
        </Transition>
      </div>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import { useI18n } from "vue-i18n";
import UiToast from "@/components/newUi/toast/UiToast.vue";
import type { ToastItem } from "@/components/newUi/toast/toastModel";
import { useToastInsets } from "@/components/newUi/toast/useToastInsets";

const props = defineProps<{
  visible: boolean;
}>();

const emit = defineEmits<{
  reload: [];
  close: [];
}>();

const { t } = useI18n();

const { insetStyle } = useToastInsets(
  ref<"top" | "bottom">("top"),
  ref<"left" | "right">("right"),
  () => (props.visible ? 1 : 0),
);

const versionToast = computed<ToastItem>(() => ({
  id: 0,
  type: "info",
  title: t("New version of application is available."),
  text: "",
  action: { label: "Load new version" },
  duration: null,
  count: 1,
  touchedAt: 0,
  restartKey: 0,
}));
</script>
